<template>
    <drop-pane-button :icon="['far', 'image']" panename="messageEditor.addImage" ref="button"
            class="editbutton" :disabled="disabled" @hide="doHide" :panetabindex="-1" :tabindex="tabindex"
            :triggerHide="managedTriggerHide">
        <div class="wrap2">
            <b-tabs small>
                <b-tab title="Upload">
                    <input type="file" accept="image/*" ref="addLinkInput" :id="$id('file')" @change="processImageFile"
                            style="display: none">
                    <div class="input">
                        <div class="file">
                            <label class="fileLabel" :for="$id('file')" tabindex="0"
                                    @focus="onFileFocus"
                                    @click="onFileClick"
                                    @keydown="onLabelKeys">{{fileInputLabel}}</label>
                        </div>
                        <div class="addButton">
                            <button @click="doAddImage" :disabled="!imageOK" type="submit"
                                    :title="$t('imageUploader.addButton')">
                                <font-awesome-icon icon="image"/>
                            </button>
                        </div>
                    </div>

                    <div class="preview" v-if="imageSrc">
                        <div class="info">
                            <div class="sizeInfo">
                                {{$t('imageUploader.sizeInfo', {size: img.size, width: img.width, height: img.height})}}
                            </div>
                        </div>
                        <div class="settings">
                            <div class="scaleLabel">{{$t('imageUploader.scale')}}</div>
                            <div class="scaler"><b-form-input inline v-model.number="scale" type="range"
                                    min="10" max="100" step="10" @input="scaleImage"/>
                            </div>
                            <div class="scaleSize">
                                {{scale}}%
                            </div>
                            <div class="qualityLabel">{{$t('imageUploader.quality')}}</div>
                            <div class="quality" v-if="fileToLoad.type === 'image/jpeg'">
                                <b-form-input inline v-model.number="quality" type="range" min="0.1" max="1"
                                        step="0.1" @input="scaleImage"/>
                            </div>
                            <div class="qualityValue">
                                {{quality}}
                            </div>
                        </div>
                        <img :width="preview.width" :height="preview.height" :src="imageSrc">
                    </div>
                </b-tab>

                <b-tab title="URL">
                    <div class="input">
                        <div class="file">
                            <input type="url" v-model="imageUrl" :placeholder="$t('imageUploader.urlPlaceholder')">
                        </div>
                        <div class="addButton">
                            <button @click="doAddImageURL" :disabled="!showUrlPreview" type="submit"
                                    :title="$t('imageUploader.addButton')">
                                <font-awesome-icon icon="image"/>
                            </button>
                        </div>
                    </div>

                    <div class="preview" v-if="showUrlPreview">
                        <div class="info">
                            <div class="sizeInfo">
                                {{$t('imageUploader.urlSizeInfo', {width: imageUrlInfo.width, height:
                                imageUrlInfo.height})}}
                            </div>
                        </div>
                        <img :width="urlPreview.width" :height="urlPreview.height" :src="imageUrl"
                                :style="{ display: showUrlPreview ? 'block' : 'none'}"
                                ref="urlPreview" @load="loadedImageUrl" @error="errorImageUrl">
                    </div>
                </b-tab>
            </b-tabs>
        </div>
    </drop-pane-button>

</template>

<script>
import DropPaneButton from '@/components/dropPaneButton';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'imageUploader',
  components: { DropPaneButton, FontAwesomeIcon },
  data() {
    return {
      fileToLoad: null,
      imageSrc: '',
      origImg: null,
      origImgSize: null,
      scale: 100,
      quality: 1,
      imageUrl: '',
      imageUrlInfo: {},
      showUrlPreview: false,
      disableTriggerHide: false
    };
  },
  props: {
    disabled: Boolean,
    triggerHide: Boolean,
    tabindex: {
      Type: [ Number, String ],
      default: 0
    }
  },
  methods: {
    onLabelKeys(evt) {
      if ((evt.key === ' ') || (evt.key === 'Enter')) {
        this.$refs.addLinkInput.click();
      }
    },
    doAddImage() {
      console.log('Send Add Image');
      this.$emit('addImage', { src: this.imageSrc, alt: this.fileToLoad.name });
      this.$refs.button.hide();
    },
    doAddImageURL() {
      if (this.showUrlPreview) {
        console.log('Send Add Image URL');
        this.$emit('addImage', { src: this.imageUrl, alt: '' });
        this.$refs.button.hide();
      }
    },
    doHide() {
      this.fileToLoad = null;
      this.imageSrc = '';
      this.origImg = null;
      this.scale = 100;
      this.quality = 1;

      this.imageUrl = '';
    },
    onFileFocus() {
      this.disableTriggerHide = false;
    },
    onFileClick() {
      this.disableTriggerHide = true;
    },
    processImageFile(event) {
      console.log('processimagefile', event);
      this.fileToLoad = event.target.files[0];
      if (/^image\//.exec(this.fileToLoad.type)) {
        const reader = new FileReader();
        reader.onload = event => {
          this.origImgSize = { width: 0, height: 0 };
          this.origImg = new Image();
          this.origImg.onload = () => {
            this.origImgSize = { width: this.origImg.width, height: this.origImg.height };
          };

          this.origImg.src = event.target.result;
          console.log('loaded image', event);
          this.scale = 100;
          this.quality = 1;

          this.scaleImage();
        };
        reader.readAsDataURL(this.fileToLoad);
      }
    },
    scaleImage() {
      if (this.scale === 100 && this.quality === 1) {
        this.imageSrc = this.origImg.src;
        console.log('scale original');
      } else {
        const canvas = document.createElement('canvas');
        canvas.width = this.origImgSize.width * this.scale / 100;
        canvas.height = this.origImgSize.height * this.scale / 100;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(this.origImg, 0, 0, canvas.width, canvas.height);
        this.imageSrc = ctx.canvas.toDataURL(this.fileToLoad.type, this.quality);
      }
    },
    loadedImageUrl() {
      console.log('loaded Image Url');
      this.showUrlPreview = true;
      const img = this.$refs.urlPreview;
      console.dir(img);
      this.imageUrlInfo = { width: img.naturalWidth, height: img.naturalHeight };
    },
    errorImageUrl() {
      console.log('error Image Url');
      this.showUrlPreview = false;
    },
    onToolbarAction(action, tb) {
      this.$refs.button.onToolbarAction(action, tb);
    }
  },
  computed: {
    imageOK() {
      let x = (this.imageSrc && this.imageSrc.length < 1024 * 1024 * 10);
      console.log('imageOK', x);
      return x;
    },
    preview() {
      if (this.imageSrc) {
        const biggestDim = Math.max(this.img.width, this.img.height);
        if (biggestDim < 300) {
          return { width: this.img.width, height: this.img.height };
        } else {
          const w = this.img.width / biggestDim * 300;
          const h = this.img.height / biggestDim * 300;
          return { width: w, height: h };
        }
      } else {
        return { width: 0, height: 0 };
      }
    },
    img() {
      if (this.origImg) {
        return {
          width: Math.floor(this.origImgSize.width * this.scale / 100),
          height: Math.floor(this.origImgSize.height * this.scale / 100),
          size: this.imageSrc.length * 6 / 8
        };
      } else {
        return { width: 0, height: 0, size: 0 };
      }
    },
    fileInputLabel() {
      if (this.fileToLoad) {
        return this.$t('imageUploader.name', { name: this.fileToLoad.name });
      } else {
        return this.$t('imageUploader.placeholder');
      }
    },
    urlPreview() {
      if (this.showUrlPreview) {
        const biggestDim = Math.max(this.imageUrlInfo.width, this.imageUrlInfo.height);
        if (biggestDim < 300) {
          return { width: this.imageUrlInfo.width, height: this.imageUrlInfo.height };
        } else {
          const w = this.imageUrlInfo.width / biggestDim * 300;
          const h = this.imageUrlInfo.height / biggestDim * 300;
          return { width: w, height: h };
        }
      } else {
        return { width: 0, height: 0 };
      }
    },
    managedTriggerHide() {
      if (this.disableTriggerHide) {
        console.log('blocked Trigger hide');
        return false;
      } else {
        console.log('Trigger hide', this.triggerHide);
        return this.triggerHide;
      }
    }
  }
};
</script>

<style scoped lang="scss">
    @import '../assets/bootstrap-style.scss';

    .wrap2 {
        width: 400px;
    }

    .input {
        display: grid;
        grid-template-columns: 369px 30px;
        grid-template-rows: 30px;
        grid-template-areas: "input button";
        overflow: hidden;
        .file {
            grid-area: input;
            width: 100%;
            label {
                width: 100%;
                display: inline-block;
                padding: 2px 5px;
                margin-bottom: 0;
                background-color: buttonface;
                border: 1px solid $gray-300;
                overflow: hidden;
                text-overflow: ellipsis;
                &:hover {
                    border: 1px solid $gray-500;
                }
            }
            input {
                width: 100%;
                padding: 1px 5px;
                margin: 0;
            }
        }
        .addButton {
            grid-area: button;
            button {
                float: right;
            }
        }
    }

    .info {
        padding: 0 5px;
    }

    .settings {
        display: grid;
        grid-template-columns: 150px 1fr 50px;
        grid-template-rows: auto auto;
        grid-template-areas: "scalelabel scaler scalesize" "qualitylabel quality qualityvalue";
        padding: 0 5px;
        border-bottom: $imageuploader-border;
        .scaleLabel {
            grid-area: scalelabel;
        }
        .scaler {
            grid-area: scaler;
        }
        .scaleSize {
            grid-area: scalesize;
        }
        .quality {
            grid-area: quality;
        }
        .qualityLabel {
            grid-area: qualitylabel;
        }
        .qualityValue {
            grid-area: qualityvalue;
        }
    }

</style>
